import React from "react";
import Card from "components/card";
import { DEPARTMENT_COLORS } from "variables/constants";

const MessageCard = ({
    recordata,
    selected = false,
    onClick,
    getStatusDisplay
}) => {

    const deptColors = DEPARTMENT_COLORS[recordata?.department] || { bg: "dark-mode-card", icon: "text-gray-600" };

    const displayStatus = getStatusDisplay 
        ? getStatusDisplay(recordata?.ticket_status ?? '')
        : (recordata?.ticket_status ?? '');

    return (
        <Card 
            onClick={onClick}
            className={`text-slate-900 flex flex-col gap-6 rounded-xl cursor-pointer transition-all duration-300 hover:shadow-md overflow-hidden ${
                selected 
                    ? "border-2 border-emerald-500 bg-gradient-to-br from-emerald-50 to-green-50 dark:from-emerald-900 dark:to-green-900"
                    : "border border-slate-200 dark-mode-card"
            }`}
        >
            <div className="pb-6 p-3">
                <div className="flex items-start gap-2.5">
                    <span className={`relative items-center justify-center flex size-full shrink-0 overflow-hidden rounded-full w-9 h-9 border-2 border-white shadow-sm text-[11px] font-semibold ${
                            selected
                                ? "bg-gradient-to-br from-emerald-500 to-green-500 text-white"
                                : `${deptColors?.bg} ${deptColors?.icon}`
                        }`}
                    >
                        {recordata?.department_initial}
                    </span>
                    <div className="flex-1 overflow-hidden">
                        <div className="flex items-start justify-between gap-2 mb-1">
                            <div className="flex-1 overflow-hidden pr-1">
                                <p className="text-[12px] font-semibold break-words title-text">
                                    {recordata?.department}
                                </p>
                                <p className="text-[11px] break-words font-medium title-text">
                                    {recordata?.tic_title}
                                </p>
                            </div>
                        </div>
                        <p className="text-[10px] line-clamp-2 mb-2 break-words muted-text">
                            {recordata?.tic_description}
                        </p>
                        <div className="flex items-center justify-between flex-wrap gap-1.5">
                            <div className="flex items-center gap-1.5 flex-wrap">
                                <span className={`status-indicator ${displayStatus} text-[9px]`}>
                                    {displayStatus}
                                </span>
                                <span className={`status-indicator ${recordata?.ticket_priority ?? ''} text-[9px]`}>
                                    {recordata?.ticket_priority}
                                </span>
                            </div>
                            <span className="text-[9px] text-slate-700 whitespace-nowrap muted-text">
                                {recordata?.created_time}
                            </span>
                        </div>
                    </div>
                </div>
            </div>  
        </Card>
    )
};
export default MessageCard;